// 📄 src/pages/admin/PermissionCatalog/PermissionCatalog.jsx
import React from "react";

export default function PermissionCatalog() {
  return (
    <div className="p-6 bg-[#f5f6f7] min-h-[calc(100vh-80px)]">
      <h1 className="text-xl font-semibold mb-2">Permission Catalog</h1>
      <p className="text-sm text-gray-600">
        Placeholder page. We’ll list all master permissions here with search,
        groups, and bulk actions.
      </p>
    </div>
  );
}
